import { TabBar, TabBarItem, theme } from '@capitalise/ui-design-system';
import { useHistory } from 'react-router-dom';
import useBusinessMenu from 'modules/Business/hooks/useBusinessMenu';
import { CollapsableBox } from '../OnBoarding/Components/OnBoardingSection/animated';

interface BusinessTabBarNavigationProps {
  show?: boolean;
}

const BusinessTabBarNavigation = ({ show }: BusinessTabBarNavigationProps) => {
  const history = useHistory();
  const { activeIndex, mobileMenuItems } = useBusinessMenu(window.location.pathname);

  const handleTabChanged = (data) => {
    const selectedItem = mobileMenuItems.find(
      ({ item }) => item.label === data.item.label || item.mobileLabel === data.item.label,
    );
    history.push(selectedItem.url);
  };

  return (
    <CollapsableBox
      position="fixed"
      width="100%"
      bottom={0}
      isExpanded={show}
      height={theme.space['2xlarge']}
      zIndex="10"
    >
      <TabBar activeIndex={activeIndex} onTabChanged={handleTabChanged} backgroundColor="white">
        {mobileMenuItems.map(({ item }) => (
          <TabBarItem key={item.label} item={{ ...item, label: item.mobileLabel }} />
        ))}
      </TabBar>
    </CollapsableBox>
  );
};

export default BusinessTabBarNavigation;
